export const OFFLINE_MESSAGES = {
    REQUEST_QUEUED: 'Request queued and will be processed when connection is restored.',
    FAILED_TO_QUEUE: 'Failed to queue request for offline processing.',
    SOMETHING_WENT_WRONG: 'Something went wrong. Please try again or contact the administrator.',
    BACK_ONLINE: 'Connection has been re-established.',
    WENT_OFFLINE: 'You are offline. Changes will be synced when connection is restored.',
    SYNC_SUCCESS: 'Successfully synced offline changes.',
    SYNC_RETRY_LATER: 'Some offline changes could not be synced. Will retry later.',
    SYNC_PARTIAL_SUCCESS: 'Some offline changes were synced successfully, others will be retried later.',
    SYNC_FAILED: 'Failed to sync offline changes.',
    DIFFERENT_TENANT: 'Some offline changes could not be synced due to tenant mismatch.',
    SERVER_UNREACHABLE: 'Server is unreachable. Changes will be retried later.',
    LIMITED_FUNCTIONALITY: 'Functionality is currently limited as there is no network connection',
    NAVIGATION_WARNING: 'Functionality is Limited for Connection Issues: If you go out of this form all the entered information will be lost. This action is not reversible.'
} as const;

export type OfflineMessage = typeof OFFLINE_MESSAGES[keyof typeof OFFLINE_MESSAGES];

export const isOfflineMessage = (message: string): message is OfflineMessage => {
    return Object.values(OFFLINE_MESSAGES).includes(message as OfflineMessage);
};
